import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "src/shared/components/Component";
import Page from "src/shared/components/Page";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
// import { ITemplate } from "src/api/types";
import { ISubscriptionPurchasePageProps } from "./../IAdminPageProps";
import LoadingSpinner from 'src/shared/components/LoadingSpinner';
// import { EditRounded } from '@material-ui/icons';
import SimpleTabs from 'src/shared/components/TabView';
import TabPanel from 'src/shared/components/TabView/TabPanel';
// import { Link } from 'react-router-dom';
const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = ISubscriptionPurchasePageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ITemplatesPageState {
  getAllPlanData?: any;
  getAllAddonData?: any;
  modalVisible: boolean;
  loader: boolean;
  selectedTab: number;
  selectPlan: any
}

export default withStyles(styles)(
  withAxios(
    class SubscriptionPurchase extends Component<IProps, ITemplatesPageState> {
      public readonly state = this.buildState({
        modalVisible: false,
        getAllPlanData: [],
        loader: false,
        selectedTab: 0,
        getAllAddonData: [],
        selectPlan: {}
      });

      public componentDidMount() {
        // this.props.loadTemplates();
        this.getAllPlanHandler()
        this.getAllAddonHandler()
      }

      public async getAllPlanHandler() {
        this.setState({ loader: true })
        const res: any = await this.buildGet(this, "payment/getPlan")()
        console.log("USERRESPO=====>", res)
        if (res.status && res?.data?.length > 0) {
          const data = res.data.sort((a: any, b: any) => a.id - b.id);
          this.setState({ getAllPlanData: data })
          this.setState({ loader: false })
        } else {
          this.setState({ loader: false })
        }
        // this.setState({ user: res })
      }

      public async getAllAddonHandler() {
        this.setState({ loader: true })
        const res: any = await this.buildGet(this, "payment/getAddonPlan")()
        if (res.status && res?.data?.length > 0) {
          const data = res.data.sort((a: any, b: any) => a.id - b.id);
          this.setState({ getAllAddonData: data })
          this.setState({ loader: false })
        } else {
          this.setState({ loader: false })
        }
        // this.setState({ user: res })
      }
      public render() {

        return (
          <>
            {this.state.loader &&<div className="loader-bg-color">
              <LoadingSpinner /></div>}
            <Page header="Subscription">
              <SimpleTabs 
              value={this.state.selectedTab}
              data={["Subscription Plan","Addon"]}
              onChange={(value: number) => {
                this.setState({ selectedTab: value })

              }} />
              <TabPanel value={this.state.selectedTab} index={0}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow className='subscription-row'>
                        <TableCell>#</TableCell>
                        <TableCell>Title</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Coach</TableCell>
                        <TableCell>Price</TableCell>
                        {/* <TableCell>Action</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.getAllPlanData?.map((row: any) => (
                        <TableRow key={row.id} className='subscription-even'>
                          <TableCell>{row.id}</TableCell>
                          <TableCell>
                            {row.title}
                          </TableCell>
                          <TableCell>{row.description || '-'}</TableCell>
                          <TableCell>{row.coachs}</TableCell>
                          <TableCell>${row.price}</TableCell>
                          {/* <TableCell>
                            <Link to={{
                              pathname: '/admin/plan-update',
                            }}
                              onClick={() => {
                                this.props.selectPlan(row)
                              }} >
                              <EditRounded />
                            </Link>
                          </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
              <TabPanel value={this.state.selectedTab} index={1}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow className='addon-row'>
                        <TableCell>#</TableCell>
                        <TableCell>Title</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Price</TableCell>
                        {/* <TableCell>Action</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.getAllAddonData?.map((row: any) => (
                        <TableRow key={row.id} className='addon-even'>
                          <TableCell>{row.id}</TableCell>
                          <TableCell>
                            {row.title}
                          </TableCell>
                          <TableCell>{row.description || '-'}</TableCell>
                          <TableCell>${row.price}</TableCell>
                          {/* <TableCell>
                            <Link to={{
                              pathname: '/admin/addon-update',
                            }}
                              onClick={() => {
                                this.props.selectAddon(row)
                              }} >
                              <EditRounded />
                            </Link>

                          </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
            </Page>
            
          </>
        );
      }



    }
  )
);



// WEBPACK FOOTER //
// ./src/features/admin/pages/SubscriptionPurchaseList/index.tsx